import instance from '@/http';

export default {
	getListDispStatementsCreateForm(date) {
		return instance().get(`dispatcher/statement/create?date=${ date }`).then(resp => resp).catch(error => error);
	},
	getListDispStatementsCreate() {
		return instance().get(`dispatcher/statement/create`).then(resp => resp).catch(error => error);
	},
	getListDispStatementsCreateList(data) {
		return instance().post(`dispatcher/statement/create/list`, data).then(resp => resp).catch(error => error);
	},
	getLoadsInfo(date, id) {
		return instance().post(`dispatcher/statement/info`, {
			date: date,
			dispatcher_id: id
		}).then(resp => resp).catch(error => error);
	},
	getLoadsInfoFilter(payload) {
		return instance().post(`dispatcher/statement/info`, payload).then(resp => resp).catch(error => error);
	},
	getRate(rate, date) {
		return instance().get(`dispatcher/statement/rate?date=${ date }&rate=${ rate }`).then(resp => resp).catch(error => error);
	}
};
